// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import type {Group} from '@mattermost/types/groups';
import {GroupSource, PluginGroupSourcePrefix} from '@mattermost/types/groups';

import {getSuggestionsSplitBy, getSuggestionsSplitByMultiple} from './user_utils';

import {General} from '../constants';

export function isSyncableSource(source: string): boolean {
    return source.toLowerCase() === GroupSource.Ldap || source.toLowerCase().startsWith(PluginGroupSourcePrefix.Plugin);
}

export function filterGroupsMatchingTerm(groups: Group[], term: string): Group[] {
    const lowercasedTerm = term.toLowerCase();
    let trimmedTerm = lowercasedTerm;
    if (trimmedTerm.startsWith('@')) {
        trimmedTerm = trimmedTerm.slice(1);
    }

    return groups.filter((group: Group) => {
        if (!group) {
            return false;
        }

        const groupSuggestions: string[] = [];

        const groupnameSuggestions = getSuggestionsSplitByMultiple((group.name || '').toLowerCase(), General.AUTOCOMPLETE_SPLIT_CHARACTERS);
        groupSuggestions.push(...groupnameSuggestions);

        const suggestions = getSuggestionsSplitBy(group.display_name.toLowerCase(), ' ');
        groupSuggestions.push(...suggestions);

        return groupSuggestions.
            filter((suggestion) => suggestion !== '').
            some((suggestion) => suggestion.startsWith(trimmedTerm));
    });
}

export function sortGroups(groups: Group[] = [], locale: string = General.DEFAULT_LOCALE): Group[] {
    return groups.sort((a, b) => {
        if ((a.delete_at === 0 && b.delete_at === 0) || (a.delete_at > 0 && b.delete_at > 0)) {
            return a.display_name.localeCompare(b.display_name, locale, {numeric: true});
        }
        if (a.delete_at < b.delete_at) {
            return -1;
        }
        if (a.delete_at > b.delete_at) {
            return 1;
        }

        return 0;
    });
}
